import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { Filter } from 'app/shared/models/filter.model';
import { ListServiceBase } from 'app/shared/services/list-base.service';
import { CaseClaimListItemViewModel } from '../models/case-claim-list-item-view.model';
import { CaseClaimListItemModel } from '../models/case-claim-list-item.model';
import { CaseClaimSearchListFilterModel } from '../models/case-claim-search-list-filter.model';
import { CaseListRequestModel } from '../models/case-list-request.model';
import { CaseClaimLocationsRequestModel } from 'app/modules/my-cases/models/case-claim-location-list.model';
import { CollectionResponse } from 'app/shared/models/collectionResponse.model';
import { LookupItem, LookupList } from 'app/shared/models/lookup-list.model';

@Injectable()
export class CaseClaimListService extends ListServiceBase {
  // divisionId: number;
  companyId: number;
  productId: number;
  inScreenPop = false;
  allowEdit = true;

  constructor(protected dependencies: ApiDependenciesService, protected dialog: MatDialog) {
    super(dependencies, dialog);

    this.initialiseFiltersSortAndPaging();
  }

  // populate initial filter properties
  private initialiseFiltersSortAndPaging() {
    this.listRequest = new CaseListRequestModel();
  }

  //#region Get Endpoints

  get baseEndpoint(): string {
    return '/portal-cases';
  }

  baseEndpointWithId(id: number): string {
    return this.baseEndpoint + '/' + id;
  }

  // a number of endpoint getters are defined in ListServiceBase
  // not all endpoints will be required for all implementations

  // OVERRIDDEN from ListServiceBase
  protected getCommandStubEndpoint(itemId: number): string {
    return this.baseEndpointWithId(itemId);
  }

  // OVERRIDDEN from ListServiceBase
  protected getListEndpoint(): string {
    return this.baseEndpoint + '/list';
  }

  //#region list loading

  // OVERRIDDEN from ListServiceBase
  // Create a new ViewModel specific to this list
  // Not necessary to set the viewmodel itemId as it is set in the viewModel constructor
  createListViewModel(dataModel: ApiEntity) {
    return new CaseClaimListItemViewModel(dataModel as CaseClaimListItemModel, this.inScreenPop, this.allowEdit);
  }

  // OVERRIDDEN from ListServiceBase
  // Map to data model from the API response item for each list row item
  // There is an assumption here that the response item directly maps to the angular model and so can just be assigned
  getMappedListItemDataModel(responseItem: any): ApiEntity {
    const model: CaseClaimListItemModel = responseItem;
    return model;
  }

  //#region get details

  // OVERRIDDEN from ListServiceBase
  // Map to data model from the API response item for the detail item (create/update)
  // The model must be derived from ApiEntity
  // There is an assumption here that the response item directly maps to the angular model and so can just be assigned
  // getMappedEditableItemDataModel(response: any): ApiEntity {
  //   const model: CaseClaimFormModel = response;
  //   return model;
  // }

  //#endregion

  setFilters(filters: Array<Filter>) {
    const nameOrReferenceFilter = filters.find(f => f.field === 'NameOrReference');

    const request = this.listRequest as CaseListRequestModel;
    request.nameOrReference = nameOrReferenceFilter ? nameOrReferenceFilter.value : '';

    const reducedFilters = filters.filter(item => item.field !== 'NameOrReference');

    super.setFilters(reducedFilters);
  }

  protected get filterLookupDataEndPoint(): string {
    return this.baseEndpoint + '/filter-lookup-data';
  }

  async getFilterLookupData(): Promise<CaseClaimSearchListFilterModel> {
    let model: CaseClaimSearchListFilterModel;
    await this.setEndpoint(this.filterLookupDataEndPoint)
      .getSingle()
      .then((response: CaseClaimSearchListFilterModel) => {
        model = response;
      });
    return Promise.resolve(model);
  }

  async refreshCompanyLocationsLookupData(input: CaseClaimLocationsRequestModel): Promise<LookupList> {
    let model: LookupList;
    await this.setEndpoint(this.baseEndpoint + '/refresh-location')
      .queryCollection(input)
      .then((response: CollectionResponse<LookupItem>) => {
        model = this.mapUserObjects(response,"companyLocations");
      });
    return Promise.resolve(model);
  }

  private mapUserObjects(queryResults: CollectionResponse<LookupItem>, name:string): LookupList {
    let result: LookupList;
      result = new LookupList(name,0,queryResults.items);
    return result;
  }

  // end of class
}
